import React from "react";
import { Plus, Flame } from "lucide-react";
import { useCart } from "../contexts/CartContext";

export const MenuCard = ({ item, index = 0, onOpen }) => {
    const { add } = useCart();
    const handleClick = () => {
        if (onOpen) onOpen(item);
        else add(item);
    };
    return (
        <article
            data-testid={`menu-card-${item.id}`}
            onClick={handleClick}
            className="group flex flex-col bg-gradient-to-b from-[#1a1a1f] to-[#0f0f12] border border-white/10 rounded-2xl overflow-hidden shadow-xl shadow-black/50 transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-red/60 hover:shadow-brand-red/20 cursor-pointer animate-fade-up"
            style={{ animationDelay: `${Math.min(index * 50, 500)}ms` }}
        >
            <div className="relative aspect-square overflow-hidden bg-black">
                <img
                    src={item.image_url}
                    alt={item.name}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                {item.featured && (
                    <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-brand-yellow text-black text-[10px] font-heading uppercase tracking-widest px-3 py-1.5 font-black shadow-lg rounded-full">
                        <Flame size={10} strokeWidth={3} /> Top Pick
                    </span>
                )}
                <span className="absolute top-3 right-3 bg-black/70 backdrop-blur-md text-brand-yellow font-heading font-black px-3 py-1.5 rounded-full text-sm border border-white/10">
                    €{item.price.toFixed(2)}
                </span>

                <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="font-heading uppercase text-lg sm:text-xl leading-tight text-white">{item.name}</h3>
                </div>
            </div>

            <div className="p-4 flex flex-col flex-1">
                <p className="text-[13px] text-white/60 leading-relaxed line-clamp-2 flex-1 min-h-[40px]">
                    {item.description}
                </p>
                <button
                    data-testid={`add-to-cart-btn-${item.id}`}
                    onClick={(e) => { e.stopPropagation(); handleClick(); }}
                    disabled={!item.available}
                    className="mt-3 w-full h-11 flex items-center justify-center gap-2 bg-gradient-to-r from-brand-red to-red-500 hover:from-brand-redhover hover:to-red-600 text-white font-heading uppercase tracking-wider text-sm font-black rounded-full transition-all hover:shadow-lg hover:shadow-brand-red/40 active:scale-95 disabled:opacity-50 disabled:pointer-events-none"
                >
                    <Plus size={16} strokeWidth={3} /> {item.available ? "Προσθήκη" : "Μη διαθέσιμο"}
                </button>
            </div>
        </article>
    );
};
